import type { AdminResourceType } from 'types/api/admin/global_search';

export const adminResourcePaths = {
  Lab: '/admin/labs/$id',
  Pharmacy: '/admin/pharmacies/$id',
  Group: '/admin/groups/$id',
  User: '/admin/users/$id',
  Invoice: '/admin/invoices/$id',
  ExpiredProductsRequest: '/admin/expired_products_requests/$id',
  Trade: '/admin/trades/$id',
} as const satisfies Record<AdminResourceType, string>;
